import { render, staticRenderFns } from "./DeleteBlacklistModal.vue?vue&type=template&id=36f9ab35"
import script from "./DeleteBlacklistModal.vue?vue&type=script&lang=js"
export * from "./DeleteBlacklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports